import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ActivityComponent } from './activity.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [ActivityComponent],
  exports: [ActivityComponent],
  providers: [],
})
export class ActivityComponentModule {}
